import React from "react"
import Typography from '@mui/material/Typography';


export const SourcesLip = () => {

return(
<div>

<Typography component="span" variant="h5" sx={{fontWeight: '700'}}>Sources: </Typography>
<br /> <br />
https://www.ncbi.nlm.nih.gov/gtr/tests/593407/ <br /> 
https://www.mdpi.com/1422-0067/22/8/4182 <br /> 
https://www.nature.com/articles/s41598-021-86801-2 (2021)<br /> 
https://my.clevelandclinic.org/health/diseases/21656-hyperlipidemia<br /> 

</div>
)
}